var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApprove = function SvgApprove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#232322",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 16.667 14.667 20 20 13.333M14.344 2.126a2.125 2.125 0 0 1 3.311 0l1.971 2.452a2.12 2.12 0 0 0 1.885.782l3.129-.34a2.124 2.124 0 0 1 2.346 2.346l-.34 3.129a2.12 2.12 0 0 0 .782 1.885l2.452 1.97a2.124 2.124 0 0 1 0 3.312l-2.46 1.962a2.13 2.13 0 0 0-.782 1.886l.34 3.129a2.124 2.124 0 0 1-2.346 2.346l-3.129-.34a2.12 2.12 0 0 0-1.884.782l-1.964 2.443a2.124 2.124 0 0 1-3.31 0l-1.97-2.45a2.13 2.13 0 0 0-1.886-.783l-3.13.34a2.122 2.122 0 0 1-2.345-2.346l.34-3.129a2.13 2.13 0 0 0-.782-1.886l-2.451-1.97a2.123 2.123 0 0 1 0-3.31l2.45-1.972a2.12 2.12 0 0 0 .783-1.885l-.34-3.128A2.123 2.123 0 0 1 7.36 5.004l3.129.34a2.13 2.13 0 0 0 1.886-.782z",
    vectorEffect: "non-scaling-stroke"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgApprove;